import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-download-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './download-modal.component.html',
  styleUrl: './download-modal.component.css'
})
export class DownloadModalComponent {
  @Input() isOpen: boolean = false;
  @Input() title: string = 'Descargar Archivo';
  @Input() message: string = 'El archivo está listo para descargar';
  @Input() fileName: string = '';
  
  @Output() onClose = new EventEmitter<void>();
  @Output() onDownload = new EventEmitter<void>();

  closeModal(): void {
    this.onClose.emit();
  }

  confirmDownload(): void {
    this.onDownload.emit();
  }
}
